module.exports = __webpack_public_path__ + "static/media/female.a0d1ec7a.svg";